import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "textarea-main-container" }
const _hoisted_2 = {
  key: 1,
  class: "character-count"
}

import { ref, onMounted } from "vue";
import { TextareaEmits, TextAreaProps } from "./componentModel/TextAreaModel";

// #region Data
/** The count of the character entered by the user in the textarea */

export default /*@__PURE__*/_defineComponent({
  __name: 'FormTextArea',
  props: {
    value: {},
    label: { default: "Textarea" },
    size: { default: "md" },
    resizable: { type: Boolean },
    maxCharacter: { default: 0 },
    allowTypingAfterMax: { type: Boolean, default: false }
  },
  emits: ["update:value"],
  setup(__props: any, { emit: __emit }) {

const characterCount = ref<number>(0);
/** The text that is binded to the textarea */
const text = ref<string>("");
// #endregion Data

const props = __props;

const emit = __emit;

// #region Methods
const textareaOnInput = (e: Event) => {
  const textarea = e.target as HTMLTextAreaElement;
  const value = textarea.value;

  characterCount.value = value.length;

  if (props.maxCharacter > 0) {
    if (value.length >= props.maxCharacter && !props.allowTypingAfterMax) {
      text.value = text.value.substring(0, props.maxCharacter);
      characterCount.value = props.maxCharacter;
    }
  }

  emit("update:value", value);
};
// #endregion Methods

// #region Lifecycle
onMounted(() => {
  if (props.value) {
    text.value = props.value;
  }
});
// #endregion Lifecycle

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, _toDisplayString(props.label), 1),
    _withDirectives(_createElementVNode("textarea", {
      class: _normalizeClass([
        'textarea-container',
        {
          small__: props.size == 'sm',
          medium__: props.size == 'md',
          large__: props.size == 'lg',
          'no-resize__': !props.resizable,
          extra__: props.maxCharacter && characterCount.value > props.maxCharacter,
        },
      ]),
      onInput: textareaOnInput,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((text).value = $event))
    }, null, 34), [
      [_vModelText, text.value]
    ]),
    (props.maxCharacter)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass([
        'character-count',
        {
          extra__: characterCount.value > props.maxCharacter,
        },
      ])
        }, _toDisplayString(characterCount.value) + " / " + _toDisplayString(props.maxCharacter) + " character" + _toDisplayString(characterCount.value > 1 ? "s" : ""), 3))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(characterCount.value) + " character" + _toDisplayString(characterCount.value > 1 ? "s" : ""), 1))
  ]))
}
}

})